export let passwordResetForm = [
 
  {
    key: "otp", label: "OTP", order: 2, type: "number",
    error: "", value: "", helperText: "", required: true, titleCase: true
  },
  {
    key: "password", label: "Password", order: 3, type: "password",
    error: "", value: "", helperText: "", required: true, titleCase: true,
    regExp: /^[A-Za-z0-9_@%$./#&!+-]{5,25}$/,
    regExMessage: "Invalid password"
  },
  {
    key: "confirmPassword", label: "Confirm Password", order: 4,
    type: "password", error: "", value: "", helperText: "", required: true, titleCase: true,
    regExp: /^[A-Za-z0-9_@%$./#&!+-]{5,25}$/,
    regExMessage: "Invalid password"
  },

];

export let changePasswordForm = [

  {
    key: "email", label: "Email", order: 1, type: "string",displayName:"Email",
    error: "", value: "", helperText: "", required: true, titleCase: true, disabled:true
  },
  {
    key: "password", label: "Password", order: 2, type: "password", displayName: "Password",
    error: "", value: "", helperText: "", required: true, titleCase: true,
    regExp: /^[A-Za-z0-9_@%$./#&!+-]{5,25}$/,
    regExMessage: "Invalid password"
  },
  {
    key: "confirmPassword", label: "Confirm Password", order: 3, displayName: "Confirm Password",
    type: "password", error: "", value: "", helperText: "", required: true, titleCase: true,
    regExp: /^[A-Za-z0-9_@%$./#&!+-]{5,25}$/,
    regExMessage: "Invalid password"
  },

];
